// Link to an enrollee's patient utilization page (/patient/:type/:id, SinglePatient.vue).
// `enrollee` is a principal (type "client") or a dependant (type "Dependent").
export function patientLink(enrollee) {
  if (!enrollee || !enrollee.id) return null;
  const type = enrollee.type === "client" ? "client" : "dependent";
  return `/patient/${type}/${enrollee.id}`;
}
